import { useSearchParams } from "react-router-dom";
import PuzzleCampaignDetails from "./components/PuzzleCampaignDetails";
import ScratchWinCampaignDetails from "./components/ScratchWinCampaignDetails";
import WheelCampaignDetails from "./components/WheelCampaignDetails";
import DefaultCampaignDetails from "./components/DefaultCampaignDetails";
import TouchWinCampaignDetails from "./components/TouchWinCampaignDetails";
import MatchWinCampaignDetails from "./components/MatchWinCampaignDetails";
import QuizCampaignDetails from "./components/QuizCampaignDetails";
import CatchGameCampaignDetails from "./components/CatchGameCampaignDetails";

export default function CampaignDetails() {
  const [searchParams] = useSearchParams();
  const gameType = parseInt(searchParams.get("gameType") || "1", 10);

  switch (gameType) {
    case 1:
      return <WheelCampaignDetails />;
    case 2:
      return <PuzzleCampaignDetails />;
    case 3:
      return <ScratchWinCampaignDetails />;
    case 4:
      return <TouchWinCampaignDetails />;
    case 5:
      return <MatchWinCampaignDetails />;
    case 6:
      return <QuizCampaignDetails />;
    case 7:
      return <CatchGameCampaignDetails />;
    default:
      return <DefaultCampaignDetails />;
  }
}
